// Discrete tick loading bar (Figma 8184:57520, company-history Loader).
// Ticks left of the progress front read bright; the rest stay dim.

import { cn } from "@/lib/utils";

const DEFAULT_TICK_COUNT = 44;

interface SegmentedProgressBarProps {
  /** 0–1 fill amount */
  progress: number;
  className?: string;
  tickCount?: number;
}

export function SegmentedProgressBar({
  progress,
  className,
  tickCount = DEFAULT_TICK_COUNT,
}: SegmentedProgressBarProps) {
  const filled = Math.round(Math.min(1, Math.max(0, progress)) * tickCount);

  return (
    <div
      aria-hidden
      className={cn(
        "bg-grey-800 flex h-9 w-full items-center justify-between overflow-hidden rounded-lg px-[9px] py-[10px]",
        className
      )}
    >
      {Array.from({ length: tickCount }).map((_, i) => (
        <span
          key={i}
          className={cn(
            "h-full w-px shrink-0",
            i < filled ? "bg-grey-0" : "bg-grey-600"
          )}
        />
      ))}
    </div>
  );
}
